import React, { useEffect, useState } from "react";
import axios from "axios";
import HeadRegresar from "../../sharecomponents/HeadRegresar";
import { API_URL } from "../../../utils/Common";
import { ToastsContainer, ToastsContainerPosition, ToastsStore } from "react-toasts";

const SeleccionCamas = (props) => {
   const planId = props.match.params.id; // -- el ID del plan
   const valvulaId = props.match.params.v;

   const [plan, setPlan] = useState({});
   const [valvula, setValvula] = useState({});
   const [seleccionCamas, setSeleccionCamas] = useState([]);
   const [totalSeleccionados, setTotalSeleccionados] = useState(0);

   useEffect(() => {
      axios
         .get(API_URL + "/getInfoSeleccionSemanas", { params: { planId, valvulaId } })
         .then((r) => {
            console.log(r.data);
            setPlan(r.data.plan);
            setValvula(r.data.valvula);
            setSeleccionCamas(r.data.seleccionCamas);
         })
         .catch((e) => console.log(e));
   }, [planId, valvulaId]);

   // -- selección de la cama
   const handleChange = (e) => {
      console.log(e.target.value, e.target.id, e.target.checked);

      if (e.target.checked === true) {
         seleccionCamas[e.target.id].seleccionado = true;
         seleccionCamas[e.target.id].tipoFlorId = plan.tipoFlor.id;
         seleccionCamas[e.target.id].nombreTipoFlor =
            plan.tipoFlor.flor.nombre_comun +
            " " +
            plan.tipoFlor.variedades.nombre +
            " " +
            plan.tipoFlor.color.descripcion;
         seleccionCamas[e.target.id].valvulaId = valvula.id;

         setTotalSeleccionados(totalSeleccionados + 1);
      } else {
         seleccionCamas[e.target.id].seleccionado = false;
         seleccionCamas[e.target.id].tipoFlorId = 0;
         seleccionCamas[e.target.id].nombreTipoFlor = "Ninguno";
         seleccionCamas[e.target.id].valvulaId = 0;

         setTotalSeleccionados(totalSeleccionados - 1);
      }

      setSeleccionCamas([...seleccionCamas]);
   };

   const selectorColor = () => {
      let camasreq = Math.ceil(plan.reqm2 / valvula.largo);
      if (totalSeleccionados < camasreq) {
         return "border border-orange-300 bg-orange-300 text-orange-900 px-2 py-1 rounded-l-md";
      } else if (totalSeleccionados === camasreq) {
         return "border border-green-300 bg-green-300 text-green-900 px-2 py-1 rounded-l-md";
      } else if (totalSeleccionados > camasreq) {
         return "border border-red-300 bg-red-300 text-red-900 px-2 py-1 rounded-l-md";
      }
   };

   const selectorColorCantidad = () => {
      let camasreq = Math.ceil(plan.reqm2 / valvula.largo);
      if (totalSeleccionados < camasreq) {
         return "border border-orange-300  text-orange-800 px-2 py-1 rounded-r-md";
      } else if (totalSeleccionados === camasreq) {
         return "border border-green-300  text-green-800 px-2 py-1 rounded-r-md";
      } else if (totalSeleccionados > camasreq) {
         return "border border-red-300  text-red-800 px-2 py-1 rounded-r-md";
      }
   };

   const finalizarSeleccion = async () => {
      let camasSeleccionadas = [];
      await Promise.all(
         seleccionCamas.map(async (s, i) => {
            if (s.tipoFlorId !== 0) {
               camasSeleccionadas.push(s);
            }
         })
      );
      console.log(camasSeleccionadas);
      // -- enviando los datos
      if (camasSeleccionadas.length > 0) {
         axios
            .post(API_URL + "/asignarCamas", { cs: camasSeleccionadas, planId, valvulaId })
            .then((r) => {
               console.log(r.data);
               props.history.push("/ver_asignaciones/" + planId);
               // ToastsStore.success('Listo');
            })
            .catch((e) => console.log(e));
      } else {
         ToastsStore.error("Seleccione el total de camas según lo requerido");
      }
   };

   return (
      <div className="w-full p-3 right-0">
         <div className="bg-white border rounded shadow-xl">
            <div className="border-b rounded-t p-3 bg-orange-900">
               <HeadRegresar titulo="Selección de Cámas" history={props.history} />
            </div>
            <div className="p-5 rounded-b">
               {/* ---- CONTENIDO --- */}
               {plan.hasOwnProperty("tipoFlor") && (
                  <h1 className="text-orange-900 font-bold mb-3">
                     {plan.tipoFlor.flor.nombre_comun} {plan.tipoFlor.variedades.nombre}{" "}
                     {plan.tipoFlor.color.descripcion}
                     <p className="text-orange-700 mb-5 pb-1 border-b-2 border-orange-800">
                        Requrimiento Cámas:{" "}
                        {(
                           (plan.total_entregado * plan.por_germinacion * plan.tipoFlor.flor.cavidad) /
                           plan.tipoFlor.flor.densidadm2 /
                           valvula.largo
                        ).toFixed(2)}{" "}
                        | Válvula: {valvula.codigo}
                     </p>
                  </h1>
               )}
               <div className="grid grid-cols-6">
                  <div>
                     <div className="flex flex-shrink-0 items-center px-2">
                        <div className={selectorColor()}>Seleccionados</div>
                        <div className={selectorColorCantidad()}>{totalSeleccionados}</div>
                     </div>
                  </div>
                  <div>
                     <button
                        className="text-white px-2 border rounded shadow py-2 bg-orange-800 hover:bg-orange-600 hover:border-orange-600 focus:outline-none"
                        onClick={() => finalizarSeleccion()}
                     >
                        Finalizar Selección
                     </button>
                  </div>
               </div>

               <table className="mt-4">
                  <thead>
                     <tr className="text-sm border border-orange-800 text-white content-center bg-orange-800">
                        <th className="px-2 py-1"> </th>
                        <th className="px-2 py-1">No. Cama</th>
                        <th className="px-2 py-1">Tipo Flor Aignada</th>
                     </tr>
                  </thead>
                  <tbody>
                     {seleccionCamas.length > 0 &&
                        seleccionCamas.map((s, i) => {
                           return (
                              <tr key={i} className={s.seleccionado ? "bg-orange-100" : ""}>
                                 <td className="text-center border px-4 py-2">
                                    {!s.ocupado && (
                                       <label className="flex items-center">
                                          <input
                                             type="checkbox"
                                             className="form-checkbox"
                                             name="seleccionado"
                                             id={i}
                                             onChange={handleChange}
                                          />
                                       </label>
                                    )}
                                 </td>
                                 <td className="text-right border px-4 py-2">{s.indice}</td>
                                 <td className="text-center border px-4 py-2">
                                    {s.nombreTipoFlor} <br />
                                    {s.planId > 0 && <span className="text-sm">(Id Plan: {s.planId})</span>}
                                 </td>
                              </tr>
                           );
                        })}
                  </tbody>
               </table>
            </div>
         </div>
         <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
      </div>
   );
};

export default SeleccionCamas;
